"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getContentBySearchText = void 0;
const tslib_1 = require("tslib");
const omit_1 = tslib_1.__importDefault(require("lodash/omit"));
const getElasticsearchQueryFromFilters_1 = require("../__common/elasticsearchQuery/getElasticsearchQueryFromFilters");
const reportHelpers_1 = require("../__common/reportHelpers");
const addFilters_1 = require("./common/addFilters");
const contentQueryHelper_1 = require("./common/contentQueryHelper");
const getAggregation_1 = require("./common/getAggregation");
function getContentBySearchText(rp, input) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const searchText = input.searchText;
        const filters = input.filters;
        // adding default filters of isPublished and isDraft for content search
        addFilters_1.addDefaultFiltersForContentSearch(filters.contentFilters);
        const projection = input.ReportProjection || {};
        const { contentProjection } = projection;
        const customProjection = contentProjection && contentProjection.custom;
        let query = getElasticsearchQueryFromFilters_1.getElasticsearchQueryForFilters(filters.contentFilters);
        const aggs = getAggregation_1.getAggregationForContentReport(customProjection);
        if (searchText && searchText !== '') {
            const searchTextQuery = {
                match: {
                    name: {
                        query: searchText,
                        fuzziness: 1,
                        max_expansions: 10,
                        prefix_length: 1,
                        boost: 10000
                    }
                }
            };
            if (!query) {
                query = {};
            }
            if (!query.bool) {
                query.bool = {};
            }
            if (!query.bool.must) {
                query.bool.must = [];
            }
            query.bool.must.push(searchTextQuery);
        }
        query = { body: { query, aggs } };
        if (projection) {
            query._source = omit_1.default(projection.contentProjection, 'custom');
        }
        let contents = [];
        let total = 0;
        let contentTypeAggregation = [];
        if (input.from || input.from === 0) {
            query.from = input.from;
            query.size = input.size || input.size === 0 ? input.size : 10;
            const elasticsearchResult = yield contentQueryHelper_1.getContentsUsingQuery(query);
            contents = elasticsearchResult.contents;
            total = elasticsearchResult.total;
            contentTypeAggregation = elasticsearchResult.contentTypeAggregation || [];
        }
        else {
            query.size = 100;
            const elasticsearchResult = yield contentQueryHelper_1.getContentsUsingQuery(query, '30s');
            const { scrollId } = elasticsearchResult;
            contentTypeAggregation = elasticsearchResult.contentTypeAggregation || [];
            total = elasticsearchResult.total;
            // Fetching remaing batch of contents using scroll
            contents = yield contentQueryHelper_1.fetchFromScroll({
                total,
                scrollId,
                contents: elasticsearchResult.contents
            });
        }
        // Fetching and setting related users like reviewer, assigner
        if (projection.relatedUserProjection) {
            yield reportHelpers_1.setRelatedUsers(rp, projection.relatedUserProjection, contents);
        }
        return { contents, total, contentTypeAggregation };
    });
}
exports.getContentBySearchText = getContentBySearchText;
//# sourceMappingURL=getContentBySearchText.js.map